import type { RefObject } from 'react';
import { useLayoutEffect, useRef } from 'react';

/**
 * A hook that will automagically scroll the connected html element into view.
 * @param dependencies when to trigger the scroll - only trigged if all are true
 * @returns ref to apply to desired element
 */
export const useScrollIntoView = <E extends HTMLElement>(
  ...dependencies: boolean[]
): RefObject<E> => {
  const viewRef = useRef<E>(null);
  useLayoutEffect(() => {
    if (!dependencies.includes(false)) {
      viewRef.current?.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return viewRef;
};
